
export class Gps {
    watchid = 0;
    //use try {await } catch
    public getLocation(options: any = { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }){
        return new Promise(success =>{ //always return a succes with object {ok,data}
            navigator.geolocation.getCurrentPosition(accept => {
                let res = {lat: accept.coords.latitude,lng: accept.coords.longitude,accuracy: accept.coords.accuracy};
                // success({ok: false,data: "Forced"});
                success({ok: true,data: res});
            },reject =>{
                success({ok: false,data: reject.message})
            },options);
        })
    }

    public updateLocation(callback: any){
        this.watchid = navigator.geolocation.watchPosition((position) => {
            callback({lat: position.coords.latitude, lng: position.coords.longitude, acc:position.coords.accuracy},
                (error: any)=>{console.log("Error in watchPosition: "+error)});
          });
    }

    public clearWatch(){
        if (this.watchid > 0){
            navigator.geolocation.clearWatch(this.watchid);
            this.watchid = 0;
        }
    }
}
